import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LandingHeader from "@/components/features/landing/LandingHeader";
import LandingFooter from "@/components/features/landing/LandingFooter";
import { useTheme } from "@/contexts/ThemeContext";

const LandingLayout: React.FC = () => {
  const { theme } = useTheme();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className={`${theme}`}>
      {/* <div className="min-h-screen bg-background-light dark:bg-background-dark"> */}
      <div className="relative min-h-screen bg-[#0C0B10] text-white overflow-hidden">
        <LandingHeader />
        <main className="relative">
          <Outlet />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
};

export default LandingLayout;
